export default "__VITE_ASSET__UPhP325i__"